module.exports = __webpack_public_path__ + "img/piazza 1.3fe78014.jpeg";